import { Point } from 'geojson';

export function toGeoJsonPoint(latLng: { lat: number; lng: number }): Point {
  return {
    type: 'Point',
    coordinates: [latLng.lng, latLng.lat],
  };
}
